export default __webpack_public_path__ + "static/media/contact_us_bg.684ffd4a.png";